import React from 'react';
import SubjectPage from '../structure/SubjectPage';
import Accordions from '../../../components/Dropdowns';

const AppliedMathsII = () => {
  const accordionContent = [
    <div key="1" className="p-4">
      <p>Complex Analysis – I : Complex Numbers and Their Geometric Representation, Polar Form of Complex Numbers. Powers and Roots, Derivative. Analytic Function, Cauchy–Riemann Equations. Laplace’s Equation, Exponential Function, Trigonometric and Hyperbolic Functions. Euler’s Formula, de’Moivre’s theorem (without proof), Logarithm. General Power. Principal Value. Singularities and Zeros. Infinity.</p>
    </div>,
    <div key="2" className="p-4">
      <p>Complex Analysis – II: Laurent Series, Residue Integration Method. Residue Integration of Real Integrals, Geometry of Analytic Functions: Conformal Mapping, Linear Fractional Transformations (Möbius Transformations), Special Linear Fractional Transformations, Conformal Mapping by Other Functions, Applications: Electrostatic Fields, Use of Conformal Mapping. Modeling, Heat Problems, Fluid Flow. Poisson’s Integral Formula for Potentials.</p>
    </div>,
    <div key="3" className="p-4">
      <p>Laplace Transforms: Definitions and existence (without proof), properties, First Shifting Theorem (s-Shifting), Transform of Derivatives and Integrals and ODEs, Unit Step Function (Heaviside Function). Second Shifting Theorem (t-Shifting), Short Impulses. Dirac’s Delta Function. Partial Fractions, Convolution. Integral Equations, Differentiation and Integration of Transforms. Solution of ODEs with Variable Coefficients, Solution of Systems of ODEs. Inverse Laplace transform and its properties. Fourier Analysis: Fourier Series, Arbitrary Period. Even and Odd Functions. Half-Range Expansions, Sturm–Liouville Problems. Fourier Integral, Fourier Cosine and Sine Transforms, Fourier Transform. Usage of fourier analysis for solution of ODEs. Inverse Fourier transform and its properties.</p>
    </div>,
    <div key="4" className="p-4">
      <p>Partial Differential Equations (PDEs): Basic Concepts of PDEs. Modeling: Vibrating String, Wave Equation. Solution by Separating Variables. Use of Fourier Series. D’Alembert’s Solution of the Wave Equation. Characteristics. Modeling: Heat Flow from a Body in Space. Heat Equation: Solution by Fourier Series. Steady Two-Dimensional Heat Problems. Dirichlet Problem. Heat Equation: Modeling Very Long Bars. Solution by Fourier Integrals and Transforms. Modeling: Membrane, Two-Dimensional Wave Equation. Rectangular Membrane. Laplacian in Polar Coordinates. Circular Membrane. Laplace’s Equation in Cylindrical and Spherical Coordinates. Potential. Solution of PDEs by Laplace Transforms.</p>
    </div>
  ];

  const tabData = [
    {
      id: 'syllabus',
      label: 'Syllabus',
      content: <Accordions accordionContent={accordionContent} />,
    },
    {
      id: 'notes',
      label: 'Notes',
      content: null, // Managed by SubjectPage
    },
    {
      id: 'important',
      label: 'Important Questions',
      content: null, // Managed by SubjectPage
    },
    {
      id: 'books',
      label: 'Books',
      content: null, // Managed by SubjectPage
    },
    {
      id: 'PYQ',
      label: 'PYQ',
      content: null, // Managed by SubjectPage
    },
    {
      id: 'videos',
      label: 'Video Lectures',
      content: null, // Managed by SubjectPage
    }
  ];

  return (
    <SubjectPage
      subjectName="Applied Mathematics-II"
      subjectKey="appliedmath2"
      branch="CSE"
      semester="2nd Semester"
      accordionContent={accordionContent}
      tabData={tabData}
      adminEmail="snaped4338@gmail.com"
      firestoreCollections={{
        notes: 'AppliedMathsIINotes',
        videos: 'AppliedMathsIIVideos'
      }}
    />
  );
};

export default AppliedMathsII;